import React from 'react'

import { useAPIGetSharedAreas } from '../../api/apiHooks/useAPIGetSharedAreas'
import { useCurrentContract } from '../../hooks/useCurrentContract/useCurrentContract'
import type { SharedArea } from '../../api/apiHooks/useAPIGetSharedAreas'
import { useAPIGetUserMetadataSuspense } from '../../api/apiHooks/useAPIGetUserMetadata'
import { UserMetadata } from '../../../common/validations'

interface GymBookingDataLoaderProps {
  children: (
    gymAreas: SharedArea[],
    isLoading: boolean,
    userMetadata: UserMetadata
  ) => React.ReactNode
}

export const GymBookingDataLoader: React.FC<GymBookingDataLoaderProps> = ({
  children,
}) => {
  const { currentContractId } = useCurrentContract()

  const { data: sharedAreas = [], isLoading } = useAPIGetSharedAreas(
    currentContractId,
    'gym'
  )
  const { data: userMetadata } = useAPIGetUserMetadataSuspense()

  return <>{children(sharedAreas, isLoading, userMetadata)}</>
}
